import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * AlphaSenseIcon - The AlphaSense logo icon
 */
export const AlphaSenseIcon = ({ size = 12, className = "", ...props }) => {
    return (_jsxs(Icon, { size: size, viewBox: "0 0 12 12", className: className, ...props, children: [_jsx("path", { d: "M11.6807 10.5125H0V11.6805H11.6807V10.5125Z", fill: "#0040FF" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.01997 0L0 9.1625H1.97206L2.47266 7.99443H6.14373L6.64432 9.1625H8.61638L4.62676 0H4.01997ZM4.32336 3.44352L5.52177 6.47746H3.12496L4.32336 3.44352ZM9.73894 9.1625H11.5745V0H9.73894V9.1625Z", fill: "#0E1318" })] }));
};
